import partnersJson from '../content/partners.json';

/**
 * Partner data configuration for TheCollective section
 *
 * The logo list is edited through the CMS (src/content/partners.json, see
 * public/admin/config.yml). The marquee layout settings below stay in code.
 *
 * @typedef {Object} Partner
 * @property {string} id - Unique identifier for the partner
 * @property {string} name - Display name of the partner
 * @property {string} logo - Path to the partner's logo image
 * @property {string} [alt] - Alt text for accessibility (defaults to name)
 * @property {Object} [size] - Custom size configuration
 * @property {string|number} [size.height] - Logo height (responsive object or value)
 * @property {string} [url] - Optional partner website URL
 * @property {boolean} [featured] - Whether this is a featured partner
 */

/**
 * List of all partners displayed in TheCollective section, in marquee order
 * @type {Partner[]}
 */
export const partners = partnersJson.partners;

/**
 * Configuration for the partner marquee display
 */
export const marqueeConfig = {
  /** Pattern for displaying partners with CTAs - 10 partners total */
  displayPattern: [
    { type: 'partners', count: 4 },
    { type: 'cta' },
    { type: 'partners', count: 3 },
    { type: 'cta' },
    { type: 'partners', count: 3 },
    { type: 'cta' },
  ],
  /** Animation duration in seconds */
  animationDuration: 40,
  /** Whether to pause on hover */
  pauseOnHover: true,
  /** Gap between items in the marquee */
  gap: 12,
  /** CTA button configuration */
  cta: {
    text: 'Join Us',
    route: '/lets-collaborate',
    style: {
      backgroundColor: '#779A0A',
      hoverColor: '#658309',
    },
  },
};

/**
 * Default logo sizing if not specified
 */
export const defaultLogoSize = {
  height: { xs: '32px', md: '40px' },
};
